// drawOla multi-file storage: content identity for cloud sync. Fork-only.

import { getSceneVersion } from "@excalidraw/element";

import type { OrderedExcalidrawElement } from "@excalidraw/element/types";

/**
 * Key of what the cloud copy of a draw would contain. Two scenes with the
 * same key are the same to the cloud. `appState` is not part of it, so pan,
 * zoom and selection changes never mark a draw dirty.
 */
export function computeSceneKey(
  elements: readonly OrderedExcalidrawElement[],
  fileIds: Iterable<string>,
  name: string,
): string {
  const files = Array.from(fileIds).sort().join(",");
  return `${getSceneVersion(elements)}:${elements.length}:${files}:${name}`;
}
